<div *ngIf="isLoading" class="spinner-wrapper">
    <!-- <div  class="spinner-bubble spinner-bubble-primary"></div> -->
    <div  class="spinner spinner-info"></div>
    <!-- <p class="mt-3">Loading please wait ...</p> -->
  </div>